import { useState } from 'react'

import {
  Button,
  Tabs,
  Tab,
  Card,
  Box,
  Grid,
  useMediaQuery,
  TablePagination,
  Typography,
} from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import { Plus as PlusIcon } from 'react-feather'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

import {
  Container,
  ContentHeader,
  FilterButton,
  Filters,
  LoadingFeedback,
  Page,
  Permitted,
} from 'components'

import { OrganizationsTable } from './components'

import constants from 'constants/index'
import * as service from 'service'
import helpers from 'helpers'
import { routes } from 'Routes'
import { useFetch, useFilter, usePagination } from 'hooks'

import useStyles from './styles'

const OrganizationsMain = () => {
  const classes = useStyles()
  const filter = useFilter()
  const theme = useTheme()
  const history = useHistory()

  const [currentTab, setCurrentTab] = useState(
    constants.organizations.KINDS.ALL_SORTS,
  )
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })
  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const defaultOrder =
    currentTab === constants.organizations.TABS[0].value
      ? constants.orderFilter.NEWLY_UPDATED
      : constants.orderFilter.NEWLY_CREATED

  const formattedDefaultOrder = helpers.functions.formatOrderValue(defaultOrder)

  const { response, isLoading, refresh } = useFetch(
    service.backoffice.organizations.get,
    {
      ...filter.filters,
      order: filter.filters?.order ?? formattedDefaultOrder,
      kind: currentTab,
      pagination: true,
      minimal: true,
      perPage,
      page,
    },
    [currentTab, filter.filters, page, perPage],
  )

  const organizationData = response?.data || []

  const handleChangeTabs = (event, value) => {
    setCurrentTab(value)
  }

  const navigateToCreate = () => history.push(routes.organizations.new)

  return (
    <Page title="Grupos Advisor">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader
          menu="Grupos Advisor"
          title="Listagem"
          subtitle="Exibição dos Grupos Advisor"
        >
          <FilterButton setDrawerOpen={filter.setDrawerOpen} />
        </ContentHeader>
        <Box my={2}>
          <Tabs
            scrollButtons="on"
            onChange={handleChangeTabs}
            textColor="primary"
            indicatorColor="primary"
            value={currentTab || constants.organizations.KINDS.ALL_SORTS}
            className={classes.borderBottom}
            variant="scrollable"
          >
            {constants.organizations.TABS.map((tab) => (
              <Tab key={tab.value} value={tab.value} label={tab.label} />
            ))}
          </Tabs>
          <Card>
            <Box display="flex" width="100%" className={classes.borderBottom}>
              <Grid container>
                <Grid item xs={6}>
                  <Box
                    width="100%"
                    p={2}
                    height="100%"
                    display="flex"
                    alignItems="center"
                  >
                    <Typography variant="h5">Grupos Advisor</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box p={2} display="flex" justifyContent="flex-end">
                    <Permitted tag={constants.permissions.ORGANIZATION.MANAGE}>
                      <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<PlusIcon />}
                        onClick={navigateToCreate}
                      >
                        Criar
                      </Button>
                    </Permitted>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <OrganizationsTable
              organizations={organizationData?.organizations}
              refresh={refresh}
            />
            <Box px={2} display="flex" justifyContent="flex-end">
              <TablePagination
                component="div"
                count={organizationData?.meta?.totalCount || 0}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                page={page - 1}
                rowsPerPage={perPage}
                rowsPerPageOptions={[5, 10, 25, 100]}
                labelRowsPerPage={isDesktop ? 'Por página' : ''}
                nextIconButtonProps={{ size: 'small' }}
                backIconButtonProps={{ size: 'small' }}
              />
            </Box>
          </Card>
          <Filters filter={filter} defaultOrder={defaultOrder}>
            <input textfieldinput="true" label="Identificador" name="id" />
            <input
              textfieldinput="true"
              label="Nome do Grupo Advisor"
              name="name"
            />
          </Filters>
        </Box>
      </Container>
    </Page>
  )
}

export default OrganizationsMain
